// extracted by mini-css-extract-plugin
export default {"container":"styles_container__s-cEb","loading":"styles_loading__415-K","rotation":"styles_rotation__9-D--"};